import { Loading3QuartersOutlined } from "@ant-design/icons";
import { Button, Form, Spin } from "antd";
import { useState } from "react";
import { SelectField } from "../../../../atoms/FormFields";
import { useForm } from "react-hook-form";

interface FormValues {
  responsible_for_account: string;
}

const antIcon = <Loading3QuartersOutlined spin />;

interface PropsType {
  onClose: () => void;
  title: string;
}

const companySizeDropdown = [
  { value: "Option 1", label: "Option 1" },
  { value: "Option 2", label: "Option 2" },
  { value: "Option 3", label: "Option 3" },
];

export default function AccountResponsiblePopUp(props: PropsType) {
  const [loading, setLoading] = useState(false);

  const { control, handleSubmit } = useForm<FormValues>();

  const onSubmit = (data: FormValues) => {
    console.log("Form submitted with data:", data);
    setLoading(false);
  };

  const btnApi = () => {
    setLoading(true);
    console.log("Button clicked to save changes");
  };

  const onCloseHandler = () => {
    props.onClose();
  };
  return (
    <Form
      layout="vertical"
      onFinish={handleSubmit(onSubmit)}
      onKeyDown={(e) => {
        if (e.key === "Enter") e.preventDefault();
      }}
    >
      <Spin indicator={antIcon} size="large" spinning={loading}>
        <div className="modalWrapper ">
          <div className="modal_header">
            <div className="title">
              <h3 style={{ marginBottom: "8px" }}>
                Change responsible for the account
              </h3>
              <p style={{ marginBottom: "0px" }}>
                Select who will manages this property’s account.
              </p>
            </div>
          </div>

          <div className="modal_content">
            <SelectField
              fieldName="responsible_for_account"
              label="Responsible for account"
              control={control}
              selectOption={companySizeDropdown}
              iProps={{
                placeholder: "Select responsible for account",
              }}
              className="bottom_0"
            />
          </div>

          <div className="modal_footer">
            <Button
              htmlType="button"
              className="outlined-btn"
              type="default"
              size="large"
              onClick={onCloseHandler}
            >
              Cancel
            </Button>

            <Button
              htmlType="button"
              className="mint-btn"
              type="primary"
              size="large"
              onClick={btnApi}
              loading={loading}
            >
              Save changes
            </Button>
          </div>
        </div>
      </Spin>
    </Form>
  );
}
